var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg55(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4466_91694)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.92796 20.8298C6.97581 19.4712 5.96541 17.4252 4.2353 17.4412C2.50537 17.4251 1.49464 19.4716 2.54268 20.8298C1.85643 21.3454 1.41177 22.1658 1.41177 23.0882V24.5H7.05883V23.0882C7.05883 22.1658 6.61417 21.3454 5.92796 20.8298ZM3.52941 19.5588C3.52941 19.1696 3.84607 18.8529 4.2353 18.8529C5.17045 18.8884 5.17021 20.2294 4.2353 20.2647C3.84607 20.2647 3.52941 19.9481 3.52941 19.5588ZM2.82353 23.0882C2.89473 21.2175 5.57652 21.2189 5.64706 23.0882H2.82353Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4574 20.8298C22.5052 19.4712 21.4948 17.4252 19.7647 17.4412C18.0348 17.4251 17.024 19.4716 18.0721 20.8298C17.3858 21.3454 16.9412 22.1658 16.9412 23.0882V24.5H22.5882V23.0882C22.5882 22.1658 22.1436 21.3454 21.4574 20.8298ZM19.0588 19.5588C19.0588 19.1696 19.3754 18.8529 19.7647 18.8529C20.6999 18.8884 20.6996 20.2294 19.7647 20.2647C19.3754 20.2647 19.0588 19.9481 19.0588 19.5588ZM18.3529 23.0882C18.4241 21.2175 21.1059 21.2189 21.1765 23.0882H18.3529Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6927 20.8298C14.7405 19.4712 13.7301 17.4252 12 17.4412C10.2701 17.4251 9.25934 19.4716 10.3074 20.8298C9.62113 21.3454 9.17647 22.1658 9.17647 23.0882V24.5H14.8235V23.0882C14.8235 22.1658 14.3789 21.3454 13.6927 20.8298ZM11.2941 19.5588C11.2941 19.1696 11.6108 18.8529 12 18.8529C12.9352 18.8884 12.9349 20.2294 12 20.2647C11.6108 20.2647 11.2941 19.9481 11.2941 19.5588ZM10.5882 23.0882C10.6594 21.2175 13.3412 21.2189 13.4118 23.0882H10.5882Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0.5V16.0294H24V0.5H0ZM22.5882 14.6176H1.41176V1.91176H22.5882V14.6176Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 13.2059C14.7246 13.2059 16.9412 10.9893 16.9412 8.26471C16.6928 1.71854 7.30621 1.72033 7.05883 8.26475C7.05883 10.9893 9.27539 13.2059 12 13.2059ZM11.2941 8.26471C11.2941 7.87548 11.6108 7.55882 12 7.55882C12.9352 7.59426 12.9349 8.93529 12 8.97059C11.6108 8.97059 11.2941 8.65393 11.2941 8.26471ZM10.6167 11.5114C10.9484 10.0058 13.0653 10.0259 13.3835 11.5113C12.5142 11.8832 11.5106 11.8937 10.6167 11.5114ZM12 4.73529C15.0691 4.72588 16.6681 8.45054 14.5873 10.6618C14.3952 10.2232 14.0918 9.83445 13.6935 9.53459C14.74 8.17581 13.7295 6.13101 12 6.14706C10.27 6.13096 9.2593 8.17746 10.3073 9.53567C9.92028 9.82649 9.61059 10.2145 9.4137 10.6629C7.33068 8.45106 8.93163 4.72546 12 4.73529Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6471 3.32353H21.1765V4.73529H17.6471V3.32353Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3529 6.14706H21.1765V7.55882H18.3529V6.14706Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3529 8.97059H21.1765V10.3824H18.3529V8.97059Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6471 11.7941H21.1765V13.2059H17.6471V11.7941Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.82353 3.32353H6.35294V4.73529H2.82353V3.32353Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.82353 6.14706H5.64706V7.55882H2.82353V6.14706Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.82353 8.97059H5.64706V10.3824H2.82353V8.97059Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.82353 11.7941H6.35294V13.2059H2.82353V11.7941Z",
    fill: "#222222"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4466_91694"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg55);
export default __webpack_public_path__ + "static/media/55.2bb39847f2ef54b4a8ba6484725033a0.svg";
export { ForwardRef as ReactComponent };